/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Guidevideo_Subtitle1Inputs */

const vi_guidevideo_subtitle1 = /** @type {(inputs: Guidevideo_Subtitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Video hướng dẫn cấu hình bán online và xử lý đơn website / Zalo Mini App. Bấm vào một video để xem.`)
};

/**

* @param {Guidevideo_Subtitle1Inputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
const guidevideo_subtitle1 = /** @type {((inputs?: Guidevideo_Subtitle1Inputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Guidevideo_Subtitle1Inputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_guidevideo_subtitle1(inputs)
});
export { guidevideo_subtitle1 as "guideVideo_subtitle" }